<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>

<!--    <keep-alive>
      <Home></Home>
    </keep-alive>-->
  </div>
</template>
<script>
//  @ is an alias to /src

import handleQuery from '@/mixin/App/handleQuery.mixin'
import checkVersion from '@/mixin/App/checkVersion.mixin'
import setGlobalMethods from '@/mixin/App/setGlobalMethods.mixin'
import initToken from '@/mixin/App/initToken.mixin'

import Home from '@/views/home/indexTestDoubleVideo.vue'

export default {
  components: { Home },
  mixins: [handleQuery, checkVersion, setGlobalMethods, initToken],
  created () {
    console.log(
      'APP created navigator',
      navigator,
      '\n======\n',
      navigator?.userAgent,
      '\n======\n',
      this.$urlParam,
      '\n======\n',
      this.$route
    )
  },
  mounted () {
    console.log('APP mounted ')
    // console.log('window.history', window.history?.length, this.$route)
  },
  destroyed () {},
  methods: {}
}
</script>

<style >
@import url(./iconfont/iconfont.css);
@import url(./style/variableStyle.css);
@import url(./style/myStyle.css);

html,
body {
  margin: 0;
  padding: 0;
  /* 防止变量失效，预设值 */
  background: #252525;/*#ededed*/
  background: var(--body-background-color);

  -webkit-text-size-adjust: 100%!important;/* 在CSS中禁止微信调整字体大小 */
  text-size-adjust: 100%!important;/* 在CSS中禁止微信调整字体大小 */
  /*其中，constant 表示兼容 iOS 设备，而 env 表示兼容 Android 设备。*/
  padding-top: constant(safe-area-inset-top); /* 兼容旧版本 */
  padding-top: env(safe-area-inset-top); /* 标准方式 */
  padding-right: constant(safe-area-inset-right);
  padding-right: env(safe-area-inset-right);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: constant(safe-area-inset-left);
  padding-left: env(safe-area-inset-left);

}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 防止变量失效，预设值 */
  max-width: 992px;
  max-width: var(--app-max-width);
  //min-width: 100vw;
  margin: auto;
  box-sizing: border-box;
  position: relative;

  /* min-width: 100vw;
  min-height: 100vh;
  position: relative;
  z-index: 4;
  background: red;
  background: #fff;
  background: var(--body-background-color); */

  /* 用来做背景 */

  z-index: 10;
  /* 防止变量失效，预设值 */
  background: #252525; /*rgba(255, 255, 255, 0.6)*/
  background: var(--app-background-color);

  /* --https://blog.csdn.net/q915730058/article/details/130503524--- */
 /* padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  height: calc(100% - env(safe-area-inset-top) - env(safe-area-inset-bottom));*/

}
.iconfont {
  font-size: 1em;
}

.my-icon-img {
  /* display: inline-block; */
  width: 1em;
  height: 1em;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
/* 超过992px */
@media only screen and (min-width: 992px) {
  #app {
    /* 防止变量失效，预设值 */
    /* margin: 12px auto;
    margin: var(--hx-page-padding) auto; */
    /* box-shadow: 0 0 10px 1px rgba(125, 125, 125, 0.1); */
    /* 防止变量失效，预设值 */
    border-radius: 16px;
    border-radius: var(--hx-card-border-radius);
  }
}
</style>
